/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  BulkUpdateRestService,
  FeeExclusionRestService,
  CostCenterRestService,
  UomRestService,
  FeeExclusionItemDto,
  FeeExclusionUpdateDto,
} from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { ENV_BASE_URL } from '@gh/config';

@Injectable()
export class EstimatingFeeExclusionsTabBusinessService implements InitViewService {

  COLUMN_ENABLE_CONDITION = {
    salesTax: (): boolean => this.getCountry() === 'us',
  };

  constructor(private feeExclusionsRest: FeeExclusionRestService,
    private uomRest: UomRestService,
    private costCenterRest: CostCenterRestService,
    private bulkUpdateRest: BulkUpdateRestService,
    private gridLayoutService: GridLayoutService,
  ) {

  }

  initView(route: ActivatedRouteSnapshot): any {

    return {
      uoms: this.uomRest.findAllShared(),
      gridLayout: this.gridLayoutService.get('feeExclusions', this.COLUMN_ENABLE_CONDITION),
    };
  }

  get(filters?: any): Observable<FeeExclusionItemDto[]> {
    const { searchString } = filters;
    return this.feeExclusionsRest.get(searchString || '');
  }

  delete(id: ID): Observable<any> {
    return this.feeExclusionsRest.delete(id);
  }

  update(dto: FeeExclusionUpdateDto): Observable<any> {
    return this.feeExclusionsRest.update(dto);
  }

  getCountry(): string {
    const baseUrl = ENV_BASE_URL.toString();
    // @ts-ignore
    switch (true) {
      case baseUrl.includes('-au') || baseUrl.includes('.au'):
        return 'au';
      case baseUrl.includes('-nz') || baseUrl.includes('.nz'):
        return 'nz';
      case baseUrl.includes('-us') || baseUrl.includes('.com'):
        return 'us';
      default:
        return 'us';
    }
  }
}
